import { ReactEditor } from 'slate-react';
import { isAtEndEdgeOfBlock, isAtStartEdgeOfBlock } from '../../helpers/selection';
import { insertNewLine } from '../../helpers/node';
import { isNotInlineElement } from '../../helpers/node-filter';

export const withBreakLinePlugin = (options?) => <T extends ReactEditor>(editor: T) => {
  const { insertBreak } = editor;
  editor.insertBreak = () => {
    const isAtEnd = isAtEndEdgeOfBlock(editor, { matchFn: isNotInlineElement(editor) }, 0);
    const isAtStart = isAtStartEdgeOfBlock(editor, { matchFn: isNotInlineElement(editor) }, 0);
    if (isAtStart || isAtEnd) {
      insertNewLine(editor);
    } else {
      insertBreak();
    }
  };

  return editor;
};
